import { Constants } from '@bode-canada/core';
import GridSortFns from '@/ui-kit/components/grid/sorting/entities/GridSortFns';

class SoldDataTableSortService {
  static get gridSortInstance() {
    return new GridSortFns(
      this.#sortByMonthAsk(),
      this.#sortByMonthDesk(),
    );
  }

  static #sortMonthFnWrapper(callback) {
    return (a, b) => {
      const aMonthIndex = Constants.MONTH_INDEXES[a];
      const bMonthIndex = Constants.MONTH_INDEXES[b];
      const isAExistedIndex = Number.isInteger(aMonthIndex);
      const isBExistedIndex = Number.isInteger(bMonthIndex);

      if (!isAExistedIndex && isBExistedIndex) {
        return 1;
      }

      if (isAExistedIndex && !isBExistedIndex) {
        return -1;
      }

      if (!isAExistedIndex && !isBExistedIndex) {
        return 0;
      }

      return callback(aMonthIndex, bMonthIndex);
    };
  }

  static #sortByMonthDesk() {
    return this.#sortMonthFnWrapper((aMonthIndex, bMonthIndex) => bMonthIndex - aMonthIndex);
  }

  static #sortByMonthAsk() {
    return this.#sortMonthFnWrapper((aMonthIndex, bMonthIndex) => aMonthIndex - bMonthIndex);
  }
}

export default SoldDataTableSortService;
